var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{class:!this.$store.state.isCollapse ? 'word-cloud':'word-cloud-mobile'},[_c('svg',{attrs:{"id":"wordcloud","width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }